var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Hr } from "@irati/ui/src/Layout";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Expander from "@irati/ui/src/Expander";
import { TextButton } from "@irati/ui/src/Button";
import { Label1 } from "@irati/ui/src/Labels";
import Markdown from "@irati/ui/src/Markdown";
var RewardDeliveryInfo = /** @class */ (function (_super) {
    __extends(RewardDeliveryInfo, _super);
    function RewardDeliveryInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardDeliveryInfo.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, reward = _a.reward, onClick = _a.onClick;
        if (!reward.termsAndConditions) {
            return null;
        }
        return (React.createElement("section", null,
            React.createElement(Hr, { small: true }),
            onClick
                ? (React.createElement(TextButton, { onClick: onClick },
                    React.createElement(FormattedMessage, { id: "reward.detail.termsAndConditions.title" }))) : (React.createElement(Expander, { showText: formatMessage({ id: "reward.detail.termsAndConditions.title" }), HeaderLabel: Label1 },
                React.createElement(Markdown, { source: reward.termsAndConditions })))));
    };
    return RewardDeliveryInfo;
}(PureComponent));
export default injectIntl(RewardDeliveryInfo);
